/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { runCancel } from "../../funcs/runCancel.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelRunRunRunIdCancelPostRequest$inboundSchema,
};

export const tool$runCancel: ToolDefinition<typeof args> = {
  name: "run-cancel",
  description: `Cancel Run`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await runCancel(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
